<script>
import { Pie } from 'vue-chartjs'
export default {
    name: 'billstoreceivebymonth',
    extends: Pie,
    props: {
        period: {
            type: Number,
            default: 0
        }
    },
    computed: {
        getToken(){
            return this.$store.getters.getToken
        }
    },
    data(){
        return {
            data: [],
            values: [],
            chartdata: {
                labels: [],
                datasets: []
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                legend: {
                    position: 'bottom',
                    fullWidth: false,
                }
            }
        }
    },
    methods: {
        updateData: function(){
            fetch(server + 'getbillstoreceivepermonth?token='+this.getToken+'&period='+this.period, {
                method: 'GET',
            })
                .then(response => (response.json()))
                .then(responseJSON => {
                    let data = responseJSON.data
                    let labels = []
                    let values = []

                    this.chartdata.labels = []
                    this.chartdata.datasets = []

                    for (let index = 0; index < data.length; index++) {
                        const element = data[index]

                        labels.push(element.DESCRICAO)
                        values.push(element.VALOR)
                    }

                    this.chartdata.labels = labels
                    this.chartdata.datasets.push({
                        label: 'Valor',
                        backgroundColor: '#28a745',
                        data: values
                    })

                    this.renderChart(this.chartdata, this.options)
                })
                .catch(error => (console.log(error)));
        }
    },
    mounted () {
        this.updateData()
    },
    watch: {
        period: function(newVal, oldVal) {
            this.updateData()
        }
    }
}
</script>
<style scoped>

</style>